@if (form) {
  <div class="settings-notification-container">
    <nimbus-form-wrapper [formGroup]="form">
      <div>
        <div class="section-label">{{ TranslationKeys.AssistantSettingsNotificationsInstantMessage | translate }}</div>
        <div class="settings-row">
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-input-slide-toggle
                id="useAudioForInstantMessages"
                formControlName="useAudioForInstantMessages"
                [label]="TranslationKeys.AssistantSettingsNotificationsActive | translate"
              >
              </nimbus-input-slide-toggle>
            </nimbus-form-control>
          </nimbus-form-row>
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-input-autocomplete
                defaultSearch
                id="audioForInstantMessages"
                formControlName="audioForInstantMessages"
                [label]="TranslationKeys.GeneralAudio | translate"
                [options]="optionsAudioFiles"
                [required]="true"
                panelClass="assistant-notification-settings"
              >
              </nimbus-input-autocomplete>
            </nimbus-form-control>
          </nimbus-form-row>
          @if (form.controls.audioForInstantMessages.value) {
            <nimbus-form-row>
              <nimbus-form-control nimbusFormControlDoubleSize>
                <nimbus-input-media-player
                  class="small-player"
                  [mode]="MediaPlayerMode.OnDemand"
                  [stopEventPropagation]="true"
                  [source]="audioService.getUrl(form.controls.audioForInstantMessages.value)"
                >
                </nimbus-input-media-player>
              </nimbus-form-control>
            </nimbus-form-row>
          }
        </div>
        <div class="section-label">{{ TranslationKeys.AssistantSettingsNotificationsExternalTask | translate }}</div>
        <div class="settings-row">
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-input-slide-toggle
                id="useAudioForExternalTasks"
                formControlName="useAudioForExternalTasks"
                [label]="TranslationKeys.AssistantSettingsNotificationsActive | translate"
              >
              </nimbus-input-slide-toggle>
            </nimbus-form-control>
          </nimbus-form-row>
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-input-autocomplete
                id="audioForExternalTasks"
                formControlName="audioForExternalTasks"
                [label]="TranslationKeys.GeneralAudio | translate"
                [options]="optionsAudioFiles"
                [required]="true"
                panelClass="assistant-notification-settings"
              >
              </nimbus-input-autocomplete>
            </nimbus-form-control>
          </nimbus-form-row>
          @if (form.controls.audioForExternalTasks.value) {
            <nimbus-form-row>
              <nimbus-form-control nimbusFormControlDoubleSize>
                <nimbus-input-media-player
                  class="small-player"
                  [mode]="MediaPlayerMode.OnDemand"
                  [stopEventPropagation]="true"
                  [source]="audioService.getUrl(form.controls.audioForExternalTasks.value)"
                >
                </nimbus-input-media-player>
              </nimbus-form-control>
            </nimbus-form-row>
          }
        </div>
        <div class="section-label">{{ TranslationKeys.AssistantSettingsNotificationsEmail | translate }}</div>
        <div class="settings-row">
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-input-slide-toggle
                id="useAudioForEmails"
                formControlName="useAudioForEmails"
                [label]="TranslationKeys.AssistantSettingsNotificationsActive | translate"
              >
              </nimbus-input-slide-toggle>
            </nimbus-form-control>
          </nimbus-form-row>
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-input-autocomplete
                id="audioForEmails"
                formControlName="audioForEmails"
                [label]="TranslationKeys.GeneralAudio | translate"
                [options]="optionsAudioFiles"
                [required]="true"
                panelClass="assistant-notification-settings"
              >
              </nimbus-input-autocomplete>
            </nimbus-form-control>
          </nimbus-form-row>
          @if (form.controls.audioForEmails.value) {
            <nimbus-form-row>
              <nimbus-form-control nimbusFormControlDoubleSize>
                <nimbus-input-media-player
                  class="small-player"
                  [mode]="MediaPlayerMode.OnDemand"
                  [stopEventPropagation]="true"
                  [source]="audioService.getUrl(form.controls.audioForEmails.value)"
                >
                </nimbus-input-media-player>
              </nimbus-form-control>
            </nimbus-form-row>
          }
        </div>
      </div>
    </nimbus-form-wrapper>
  </div>
}
